import React from 'react';
import styled from 'styled-components';

import { Button, Form, Icon, Input, Segment, Table } from 'semantic-ui-react';

import { RecommendationActivity } from './types/RecommendationActivity';

type PhaseTabProps = {
  phaseIndex: number;
  addActivity: (phaseIndex: number) => void;
  phaseData: {
    activities: RecommendationActivity[];
  };
  removeActivity: (phaseIndex: number, activityIndex: number) => void;
  updateActivityTitle: (phaseIndex: number, activityIndex: number, activityTitle: string) => void;
  updateBCorpRelevance: (phaseIndex: number, activityIndex: number, bCorpRelevance: string) => void;
  addTask: (phaseIndex: number, activityIndex: number) => void;
  removeTask: (phaseIndex: number, activityIndex: number, taskIndex: number) => void;
  updateTaskInfo: (
    phaseIndex: number,
    activityIndex: number,
    taskIndex: number,
    infoType: string,
    infoValue: string
  ) => void;
  openResourceModal: (
    phaseIndex: number,
    activityIndex: number,
    taskIndex: number,
    resources: any[]
  ) => void;
};
export const PhaseTab = (props: PhaseTabProps) => {
  const {
    phaseData,
    phaseIndex,
    addActivity,
    removeActivity,
    updateActivityTitle,
    updateBCorpRelevance,
    addTask,
    removeTask,
    updateTaskInfo,
    openResourceModal,
  } = props;

  function renderTask(task: any, taskIndex: number, activityIndex: number) {
    return (
      <Table.Row key={taskIndex}>
        <Table.Cell>
          <Form.TextArea
            value={task.task}
            onChange={e =>
              updateTaskInfo(phaseIndex, activityIndex, taskIndex, 'task', e.target.value)
            }
            style={{
              width: '100%',
              height: '40px',
              padding: '5px',
            }}
          />
        </Table.Cell>
        <Table.Cell>
          <Input
            value={task.metric}
            onChange={e =>
              updateTaskInfo(phaseIndex, activityIndex, taskIndex, 'metric', e.target.value)
            }
            style={{ width: '100%' }}
          />
        </Table.Cell>
        <Table.Cell textAlign="center">
          <Button
            basic
            content={`Manage (${task['content']?.length ?? 0})`}
            onClick={() =>
              openResourceModal(phaseIndex, activityIndex, taskIndex, task['content'] ?? [])
            }
          />
        </Table.Cell>
        <Table.Cell textAlign="center">
          <Button
            icon
            title="Delete Task"
            onClick={(e: any) => {
              e.stopPropagation(); // prevent row's onClick from firing
              removeTask(phaseIndex, activityIndex, taskIndex);
            }}
          >
            <Icon name="trash alternate" color="grey" />
          </Button>
        </Table.Cell>
      </Table.Row>
    );
  }

  function renderActivity(activityData: any, activityIndex: number) {
    return (
      <ActivityContainer
        key={activityIndex}
        style={{
          backgroundColor: '#f7f7f7',
          padding: '10px',
          borderRadius: '5px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Form style={{ padding: '5px' }}>
          <Form.Field>
            <label>Activity Title</label>
            <Input
              fluid
              value={activityData.activityTitle}
              onChange={e => updateActivityTitle(phaseIndex, activityIndex, e.target.value)}
              style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
            />
          </Form.Field>
          <Form.Field>
            <label>B-Corp Relevance</label>
            <Input
              fluid
              value={activityData.bCorpRelevance ?? ''}
              onChange={e => updateBCorpRelevance(phaseIndex, activityIndex, e.target.value)}
              style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
            />
          </Form.Field>
          <Table
            celled
            structured
            style={{
              borderRadius: '5px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            }}
          >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={7}>Task</Table.HeaderCell>
                <Table.HeaderCell width={4}>Completion Metric</Table.HeaderCell>
                <Table.HeaderCell width={2} textAlign="center">
                  Resources
                </Table.HeaderCell>
                <Table.HeaderCell width={2} textAlign="center">
                  Actions
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {activityData.tasks.map((task: any, taskIndex: number) =>
                renderTask(task, taskIndex, activityIndex)
              )}
              <Table.Row>
                <Table.Cell colSpan="4" textAlign="left">
                  <Button
                    icon
                    labelPosition="left"
                    primary
                    onClick={() => addTask(phaseIndex, activityIndex)}
                  >
                    <Icon name="plus" />
                    Add Task
                  </Button>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Form>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '10px',
          }}
        >
          <Button
            icon
            labelPosition="left"
            onClick={() => {
              removeActivity(phaseIndex, activityIndex);
            }}
            style={{
              marginLeft: '10px',
              display: 'flex',
              justifyContent: 'right',
            }}
          >
            Delete Activity
            <Icon name="trash alternate" />
          </Button>
        </div>
      </ActivityContainer>
    );
  }
  return (
    <>
      {phaseData.activities.map((activity, activityIndex) =>
        renderActivity(activity, activityIndex)
      )}
      <Button icon labelPosition="left" primary onClick={() => addActivity(phaseIndex)}>
        <Icon name="plus" />
        Add Activity
      </Button>
    </>
  );
};

const ActivityContainer = styled(Segment)`
  margin-bottom: 20px !important;
`;
